import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  TemplateRef,
  ElementRef
} from '@angular/core';
import {
  trigger,
  style,
  state,
  transition,
  animate
} from '@angular/animations';
import { map } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'takeoff-group-export-xl',
  templateUrl: './export-xl.component.html',
  styleUrls: ['./export-xl.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      )
    ])
  ]
})
export class ExportXlComponent implements OnInit {
  @ViewChild('TABLE') table: ElementRef;
  @Input('table-header') displayedColumns: string[] = [];
  @Input('table-data') ELEMENT_DATA = [];
  @Input('table-title') tableTitle: '';
  @Input('advanced-filter') advancedFilter: boolean = false;
  @Input() isCheckbox: boolean = false;
  @Input() isExpand: boolean = false;
  @Input() showLoader: boolean = false;
  @Input() templateRef: TemplateRef<any>;
  rnavShow: boolean = false;
  dataSource = new MatTableDataSource();
  selection = new SelectionModel(true, []);
  skipValue: any;
  previousIndex: number;
  columns: any = [];
  expandedElement: null;
  noData = this.dataSource.connect().pipe(map(data => data.length == 0));

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() onCheck = new EventEmitter<boolean>();
  @Output() onCheckAll = new EventEmitter<boolean>();
  @Output() onActionClick = new EventEmitter<any>();
  @Output() onRowExpandClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {
    this.displayedColumns = [...new Set(this.displayedColumns)];
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.columns = this.displayedColumns.map(item => {
      return { field: item };
    });
    this.noData = this.dataSource.connect().pipe(map(data => data.length == 0));
  }

  ngOnChanges() {
    this.displayedColumns = [...new Set(this.displayedColumns)];
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this.isCheckbox
      ? [this.displayedColumns.unshift('select'), (this.skipValue = 1)]
      : (this.skipValue = 0);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.columns = this.displayedColumns.map(item => {
      return { field: item };
    });
    this.noData = this.dataSource.connect().pipe(map(data => data.length == 0));
    this.selection.clear();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.selection.select(row));
    this.onCheckAll.emit(this.isAllSelected());
  }

  selectedRow(event, row) {
    let selectedRow: any = {
      checked: event.checked,
      rowData: row
    };
    this.onCheck.emit(selectedRow);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${
      this.selection.isSelected(row) ? 'deselect' : 'select'
    } row ${row.position + 1}`;
  }

  setDisplayedColumns() {
    this.columns.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.field;
    });
  }

  handleAction(type, data) {
    this.onActionClick.emit({ action_type: type, rowData: data });
  }

  onExpandRow(data) {
    this.onRowExpandClick.emit({ rowData: data });
  }

  down(url) {}

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'SheetJS.xlsx');
  }
}
